<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="1200px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
            <span class="px-3">{{ $t("View Sale's Information") }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <invoice-header class="only-for-print" />

        <v-layout column>
          <!-- %%%%%%%%%%%%%%%%% Print Section Title %%%%%%%%%%%%%%%%% -->
          <table class="section-title-table only-for-print">
            <tr>
              <th class="section-title-content">{{ $t('Sales') }}</th>
            </tr>
          </table>

          <v-layout row wrap class="invoice-content">
            <v-flex xs12 sm12 :class="{ 'px-4': $vuetify.breakpoint.smAndUp }">
              <v-layout row wrap>
                <table class="info-table" style="width: 100%">
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Bill Number') }}
                      </div>
                      <strong>{{ viewInfo.bill_auto_number || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Salesman') }}</div>
                      <strong>{{ viewInfo.sale_man_name || '-' }}</strong>
                    </td>
                    <td
                      class="td-padding-bottom not-printable"
                      v-if="viewInfo.attachment != null && viewInfo.attachment != 'undefined'"
                    >
                      <a
                        :href="`${baseUrls.images}/${viewInfo.attachment}`"
                        target="_blank"
                        style="padding-top: 10px; text-decoration: none"
                      >
                        <v-icon color="blue" size="20" :right="$vuetify.rtl" :left="!$vuetify.rtl"
                          >fa-external-link-alt</v-icon
                        >
                        <span style="color: #2196f3">{{ $t('Attachment') }}</span>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Customer Name') }}
                      </div>
                      <strong>{{ viewInfo.customer_name || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Receive Type') }}
                      </div>
                      <strong>{{ $t(viewInfo.receive_type) }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Bill Date') }}</div>
                      <strong v-if="viewInfo.bill_date">
                        {{ viewInfo.bill_date }}
                      </strong>
                      <strong v-else>-</strong>
                    </td>
                  </tr>
                </table>

                <table class="printed-table" cellspacing="0">
                  <thead>
                    <tr class="only-for-print">
                      <td>
                        <div class="header-space">&nbsp;</div>
                      </td>
                    </tr>
                    <tr>
                      <th xs1 class="pa-2 view-table-header">#</th>
                      <th class="view-table-header" xs5 pa-2>
                        {{ $t('Product') }}
                      </th>
                      <th class="view-table-header" xs5 pa-2 v-if="hasBrand">
                        {{ $t('Brand / Made In') }}
                      </th>
                      <th class="view-table-header" xs5 pa-2 v-if="hasDetail">
                        {{ $t('Detail') }}
                      </th>
                      <th class="view-table-header" xs5 pa-2 v-if="hasCollection">
                        {{ $t('Collections') }}
                      </th>
                      <th class="view-table-header" xs2 pa-2>
                        {{ $t('Quantity') }}
                      </th>
                      <!--                      <th class="view-table-header" xs2 pa-2>-->
                      <!--                        {{ $t('Returned Quantity') }}-->
                      <!--                      </th>-->
                      <th class="view-table-header" xs2 pa-2>
                        {{ `${$t('Price')} (${systemCurrency})` }}
                      </th>
                      <th class="view-table-header" xs2 pa-2>
                        {{ `${$t('Total')} (${systemCurrency})` }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in rowNumbers" :key="index">
                      <td class="view-table-row">
                        <p class="view-table-content">{{ index + 1 }}</p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.product_name[index] }}
                        </p>
                      </td>
                      <td class="view-table-row" v-if="hasBrand">
                        <p class="view-table-content">
                          {{ viewInfo.brand_or_made_in[index] }}
                        </p>
                      </td>
                      <td class="view-table-row" v-if="hasDetail">
                        <p class="view-table-content">
                          {{ viewInfo.sale_detail[index] }}
                        </p>
                      </td>
                      <td class="view-table-row" v-if="hasCollection">
                        <p class="view-table-content">
                          {{ viewInfo.collection_name[index] }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.sale_quantity[index] | currency }}
                        </p>
                      </td>
                      <!--                      <td class="view-table-row">-->
                      <!--                        <p class="view-table-content">-->
                      <!--                          {{ viewInfo.returned_quantity[index] | currency }}-->
                      <!--                        </p>-->
                      <!--                      </td>-->
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.sale_price[index] | currency }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.total[index] | currency }}
                        </p>
                      </td>
                    </tr>
                    <tr class="last-table-row-for-currency" v-if="viewInfo.discount_amount > 0">
                      <td class="last-table-row" :colspan="getColSpan()">
                        <p class="view-table-content">
                          {{ `${$t('Total Amount')} (${systemCurrency})` }}
                        </p>
                      </td>
                      <td class="last-table-row2">
                        <p class="view-table-content">
                          {{ viewInfo.total_amount | currency }}
                        </p>
                      </td>
                    </tr>
                    <tr class="last-table-row-for-currency" v-if="viewInfo.discount_amount > 0">
                      <td class="last-table-row" :colspan="getColSpan()">
                        <p class="view-table-content">
                          {{ `${$t('Discount Amount')} (${systemCurrency})` }}
                        </p>
                      </td>
                      <td class="last-table-row2">
                        <p class="view-table-content">
                          {{ viewInfo.discount_amount | currency }}
                        </p>
                      </td>
                    </tr>
                    <tr class="last-table-row-for-currency">
                      <td class="last-table-row" :colspan="getColSpan()">
                        <p class="view-table-content">
                          {{ `${$t('Net Amount')} (${systemCurrency})` }}
                        </p>
                      </td>
                      <td class="last-table-row2">
                        <p class="view-table-content">
                          {{ viewInfo.net_amount | currency }}
                        </p>
                      </td>
                    </tr>
                    <tr class="last-table-row-for-currency">
                      <td class="last-table-row" :colspan="getColSpan()">
                        <p class="view-table-content">
                          {{ `${$t('Received Amount')} (${systemCurrency})` }}
                        </p>
                      </td>
                      <td class="last-table-row2">
                        <p class="view-table-content">
                          {{ viewInfo.received_amount | currency }}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="only-for-print">
                      <td>
                        <div style="height: 50px;">&nbsp;</div>
                      </td>
                    </tr>
                  </tfoot>
                </table>

                <v-layout row wrap justify-center mt-4 v-if="receiveNumbers > 0">
                  <table>
                    <tr>
                      <th class="section-title-content">
                        {{ $t('Receive Details') }}
                      </th>
                    </tr>
                  </table>

                  <v-flex xs10>
                    <v-divider />
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="invoice-content" mt-4 v-if="receiveNumbers > 0">
                  <v-flex xs12 sm12>
                    <v-layout row wrap>
                      <table class="printed-table" cellspacing="0">
                        <thead>
                          <tr>
                            <th xs1 class="pa-2 view-table-header">#</th>
                            <th class="view-table-header" xs3 pa-2>
                              {{ $t('Date') }}
                            </th>
                            <th class="view-table-header" xs2 pa-2>
                              {{ `${$t('Amount')} (${systemCurrency})` }}
                            </th>
                            <th class="view-table-header" xs2 pa-2>
                              {{ `${$t('Amount')} (${systemCurrency === $t('USD') ? $t('IQD') : $t('USD')})` }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in receiveNumbers" :key="index">
                            <td class="view-table-row">
                              <p class="view-table-content">{{ index + 1 }}</p>
                            </td>
                            <td class="view-table-row">
                              <p class="view-table-content">
                                {{ viewInfo.receive_date[index] }}
                              </p>
                            </td>
                            <td class="view-table-row">
                              <p class="view-table-content">
                                {{ viewInfo.amount_main[index] | currency }}
                              </p>
                            </td>
                            <td class="view-table-row">
                              <p class="view-table-content">
                                {{ viewInfo.amount_secondary[index] | currency }}
                              </p>
                            </td>
                          </tr>
                          <tr class="last-table-row-for-currency">
                            <td class="last-table-row" colspan="2">
                              <p class="view-table-content">
                                {{ `${$t('Total Received')}` }}
                              </p>
                            </td>
                            <td class="last-table-row2" colspan="2">
                              <p class="view-table-content">
                                {{ viewInfo.received_amount | currency }}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr class="only-for-print">
                            <td>
                              <div class="footer-space">&nbsp;</div>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <invoice-footer
                  :showSignatureSection="true"
                  :accountantName="viewInfo.accountant"
                  :payerRecipientName="viewInfo.customer_name"
                  :payerOrRecipient="$t('Payer')"
                  class="only-for-print"
                />
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">
            {{ $t('Close') }}
          </v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import ignored from 'print-this'

export default {
  name: 'view-component',

  components: {
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      viewInfo: {
        sale_id: 0,
        bill_auto_number: '',
        attachment: '',
        customer_name: '',
        bill_date: '',
        total_amount: '',
        receive_type: '',
        discount_amount: '',
        net_amount: '',
        sale_man_name: '',
        accountant: '',
        received_amount: 0,
        product_name: [],
        collection_name: [],
        sale_detail: [],
        brand_or_made_in: [],
        sale_quantity: [],
        returned_quantity: [],
        sale_price: [],
        total: [],
        receive_date: [],
        amount_main: [],
        amount_secondary: []
      },
      rowNumbers: 0,
      receiveNumbers: 0
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      settings: 'configurations/getSystemSettings',
      saleInfo: 'sales/getSaleInfo'
    }),
    hasCollection() {
      return this.settings.production_collections === 'Active'
    },
    hasBrand() {
      return this.settings.product_brand_or_made_in === 'Active'
    },
    hasDetail() {
      return this.settings.sale_detail === 'Active'
    },
    bothOfThem() {
      return this.hasCollection && this.hasBrand && this.hasDetail
    },
    twoOfThem() {
      return (
        (this.hasCollection ? this.hasBrand || this.hasDetail : this.hasBrand && this.hasDetail) && !this.bothOfThem
      )
    },
    oneOfThem() {
      return this.hasCollection || this.hasBrand || this.hasDetail
    }
  },

  watch: {
    viewDialog: {
      immediate: false,
      handler() {
        if (this.viewDialog) {
          this.rowNumbers = this.saleInfo.data_detail.length
          this.viewInfo.bill_auto_number = this.saleInfo.data.bill_auto_number
          this.viewInfo.customer_name = this.saleInfo.data.customer_name
          this.viewInfo.bill_date = this.saleInfo.data.bill_date
          this.viewInfo.sale_man_name = this.saleInfo.data.sale_man_name
          this.viewInfo.total_amount = this.saleInfo.data.total_amount
          this.viewInfo.discount_amount = this.saleInfo.data.discount_amount
          this.viewInfo.net_amount = this.saleInfo.data.net_amount
          this.viewInfo.receive_type = this.saleInfo.data.receive_type
          this.viewInfo.attachment = this.saleInfo.data.attachment
          this.viewInfo.sale_id = Number(this.saleInfo.data.sale_id)
          this.viewInfo.accountant = this.saleInfo.data.accountant
          this.viewInfo.received_amount = this.saleInfo.data.received_amount

          this.viewInfo.product_name = []
          this.viewInfo.brand_or_made_in = []
          this.viewInfo.sale_detail = []
          this.viewInfo.collection_name = []
          this.viewInfo.sale_quantity = []
          this.viewInfo.returned_quantity = []
          this.viewInfo.sale_price = []
          this.viewInfo.expire_date = []
          this.viewInfo.total = []

          this.saleInfo.data_detail.forEach(c => {
            this.viewInfo.product_name.push(c.product_name)
            this.viewInfo.brand_or_made_in.push(c.brand_or_made_in)
            this.viewInfo.sale_detail.push(c.detail)
            this.viewInfo.collection_name.push(c.collection_name)
            if (c.collection_name !== null) {
              this.viewInfo.sale_quantity.push(c.sale_collection_quantity)
              this.viewInfo.sale_price.push(c.sale_collection_price)
              this.viewInfo.total.push(c.total_collection)
            } else {
              this.viewInfo.sale_quantity.push(c.sale_quantity)
              this.viewInfo.sale_price.push(c.sale_price)
              this.viewInfo.total.push(c.total)
            }
            this.viewInfo.returned_quantity.push(Number(c.returned_quantity))
          })

          this.receiveNumbers = this.saleInfo.receive_detail.length
          this.viewInfo.receive_date = []
          this.viewInfo.amount_main = []
          this.viewInfo.amount_secondary = []

          this.saleInfo.receive_detail.forEach(c => {
            this.viewInfo.receive_date.push(c.receive_date)
            this.viewInfo.amount_main.push(c.amount_main)
            this.viewInfo.amount_secondary.push(c.amount_secondary)
          })
        }
      }
    }
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    getColSpan() {
      if (this.bothOfThem) {
        return 7
      } else if (this.twoOfThem) {
        return 6
      } else if (this.oneOfThem) {
        return 5
      } else {
        return 4
      }
    },

    printMe() {
      // helpers.doPrinting(true)
      let onlyForPrint = document.querySelectorAll('.only-for-print')
      let notPrintable = document.querySelectorAll('.not-printable')
      let invoiceContent = document.querySelector('.invoice-content')
      let theDialogContent = document.querySelector('.view-dialog-content')
      let infoTable = document.querySelector('.info-table')
      theDialogContent.classList.remove('grey')
      infoTable.classList.add('add-padding-for-info-table')
      invoiceContent.style.marginTop = '90px'
      notPrintable.forEach(element => {
        element.style.display = 'none'
      })
      onlyForPrint.forEach(element => {
        element.style.display = 'block'
      })
      document.querySelector('.printed-table').style.marginTop = '-120px'

      this.$htmlToPaper('printArea', () => {
        infoTable.classList.remove('add-padding-for-info-table')
        theDialogContent.classList.add('grey')
        invoiceContent.style.marginTop = '0px'
        onlyForPrint.forEach(element => {
          element.style.display = 'none'
        })
        notPrintable.forEach(element => {
          element.style.display = 'flex'
        })
        document.querySelector('.printed-table').style.marginTop = '0px'
      })
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
